import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { AppSettings } from '../../../shared/app.settings';
import { GoogleRoute } from '../../../shared/models/google-route.model';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { UserCommonService } from '../../../shared/services/user-common.service';
declare const google: any;

@Component({
  selector: 'app-booking-history-details',
  templateUrl: './booking-history-details.component.html'
})

export class BookingHistoryDetailsComponent implements OnInit {
  bookingId: any;
  passengerId: any;
  message: Message[] = [];
  map: any;
  marker;
  maxRating = ['1', '2', '3', '4', '5'];
  sendEmailPopup = false;
  refundAmountPopup = false;
  labelBack;
  tripDetailsInfo = [];
  driverInfo = null;
  estimatesInfo = null;
  passengerInfo = null;
  vehicleInfo = null;
  invoiceInfo = null;
  tourBookingInfo = null;
  tripStatistics = [];
  fareBreakDown = [];
  tripNote: any = false;
  biddings = [];

  bookingErrors = [{
    'bookingInfo.amount': false,
    'bookingInfo.profilePassword': false
  }];

  mapImageUrl: string = AppSettings.GET_FILE_URL;
  routeImageUrl = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonBindingDataService,
    private userCommonService: UserCommonService
  ) { }

  ngOnInit() {
    this.bookingId = this.route.snapshot.queryParams['id'];

    this.passengerId = this.route.snapshot.queryParams['passengerId'];

    this.labelBack = this.commonService.getLabel('label_back');
    this.tripNote = this.commonService.getTenantConfigValue(AppSettings.TRIP_NOTE);


    this.getBookingDetails();
  }

  getBookingDetails() {
    this.commonService.fetchTourBooking(this.bookingId).subscribe(results => {
      this.tripDetailsInfo = results.tripDetails;
      if (this.tripDetailsInfo) {
        this.tripDetailsInfo.splice(0, 1);
      }
      this.driverInfo = results.driverInfo;
      this.estimatesInfo = results.estimatesInfo;
      this.tourBookingInfo = results.tourBookingInfo;
      this.invoiceInfo = results.invoiceInfo;
      this.vehicleInfo = results.vehicleInfo;
      this.tripStatistics = results.tripStatistics;
      this.passengerInfo = results.passengerInfo;
      this.fareBreakDown = results.fareBreakDownList;

      if (this.invoiceInfo.staticMapImage !== undefined && this.invoiceInfo.staticMapImage !== null) {
        this.routeImageUrl = this.mapImageUrl + '/' + this.invoiceInfo.staticMapImage;
      }

      if (this.tourBookingInfo !== null) {
        const origin = {
          lat: this.tourBookingInfo.sourceLatitude,
          lng: this.tourBookingInfo.sourceLongitude,
        };
        const destingation = {
          lat: this.tourBookingInfo.destinationLatitude,
          lng: this.tourBookingInfo.destinationLongitude
        };
        this.calculateAndDisplayRoute(origin, destingation);
      }
    }, (error) => {

      this.message = [];
      this.message.push({ severity: 'error', summary: 'Error Message', detail: error.general[0].message });
    });
  }

  calculateAndDisplayRoute(origin, destination, currentLocation?) {
    const map = new google.maps.Map(document.getElementById('tripMap'), {
      center: origin,
      zoom: 6,
      gestureHandling: 'cooperative',
      zoomControl: true
    });

    const routeData: GoogleRoute = {
      "originLatitude": origin.lat,
      "originLongitude": origin.lng,
      "destinationLatitude": destination.lat,
      "destinationLongitude": destination.lng,
      "waypoints": []
    };

    this.userCommonService.getGoogleMapRoute(routeData).subscribe({
      next: (result) => {
        const decodedPath = this.userCommonService.decodePolyline(result.routes[0].polyline.encodedPolyline);
        const route = new google.maps.Polyline({
          path: decodedPath,
          geodesic: true,
          strokeColor: AppSettings.DEFAULT_MAP_ROUTE_COLOR,
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });
        route.setMap(map);
        
        if (currentLocation) {
          this.marker = new google.maps.Marker;
          this.marker.setMap(map);
          this.marker.setIcon('/assets/images/temp/taxi_busy.png');
          this.marker.setPosition(currentLocation);
        }
      },
      error: (error) => {
        this.mapMessage('Failed to get route information');
      }
    });
  }

  onClickBack() {
    this.router.navigate(['passengers/passenger-details'], { queryParams: { passengerId: this.passengerId } });
  }

  mapMessage(status) {
    this.message = [];
    this.message.push({ severity: 'success', summary: 'Confirmed', detail: status });
  }
}



